import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import Masonry from 'react-masonry-component';

import { getMainDomain } from 'helpers/whiteLabel';

import Loader from 'components/layout/Loader';


import CmsElementHero from 'components/cms/elements/CmsElementHero';

import OrdersList from 'components/layout/dashboard/customer/OrdersList';
import InvoicesList from 'components/layout/dashboard/customer/InvoicesList';
import Data from "../../Data";
import Breadcrumb from "../Breadcrumb";
import EditionsList from "./customer/EditionsList";
import OrderTotals from "components/layout/dashboard/OrderTotals";
import may from "js/security";
import { ROLE_WL_ADMIN } from "js/constants";
import OrderItems from 'components/layout/dashboard/OrderItems';


class DashboardCustomer extends React.Component {
  getBackgroundUrlParam = () => {
    const { projectConfig } = this.props;
    return getMainDomain(projectConfig.data, true, false) + '/img/default_customer_portal_image.jpg';
  };

  getHeaderMessageParam = () => {
    const {
      intl: { formatMessage },
      projectConfig,
    } = this.props;

    return (
      '<div class="p-t-100 p-b-30"><h2>' +
      formatMessage({ id: 'your_project_dashboard' }, { project: projectConfig.data.name }) +
      '</h2></div>'
    );
  };

  render() {
    const { intl: { messages }, appIntl, user,  data, user: { roles } } = this.props;

    const pending = data.pending;

    return (
      <div className="padding-25 sm-padding-10">
        <Data dataName="dashboard" url="/api/dashboard.json" data={data} />
        <Breadcrumb crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }]} />
        <h1>
          <FormattedMessage
            id="welcome_message"
            values={{
              name: user.profile.first_name + ' ' + user.profile.last_name,
            }}
          />
        </h1>

        <Grid>
          <Row className="p-t-20 p-b-50">
            {pending ? (
              <Col xs={12}>
                <Loader />
              </Col>
            ) : (
              <>
                {may(ROLE_WL_ADMIN, roles) && <><OrderTotals data={data} /></>}
                {may(ROLE_WL_ADMIN, roles) && <><OrderItems data={data} /></>}
                <Masonry
                  className="customer-dashboard"
                  elementType="div"
                  options={{
                    transitionDuration: 200,
                    itemSelector: '.grid-item',
                    // use element for option
                    columnWidth: '.grid-sizer',
                    percentPosition: true,
                  }}
                  disableImagesLoaded={false}
                  updateOnEachImageLoad
                >
                  <Col xs={6} className="grid-sizer" />
                  {/* display orders list */}
                  <OrdersList list={{data: {count: data.data.open_orders ? data.data.open_orders.length : 0, list: data.data.open_orders} } } />
                  <EditionsList list={{data: {count: data.data.last_editions ? data.data.last_editions.length : 0, list: data.data.last_editions} } } title={messages.latest_editions} />
                  <InvoicesList list={{data: {count: data.data.invoices_over_due ? data.data.invoices_over_due.length : 0, list: data.data.invoices_over_due} } } title={messages.overdue_invoices}/>
                  <InvoicesList list={{data: {count: data.data.invoices ? data.data.invoices.length : 0, list: data.data.invoices} } } title={messages.latest_invoices}/>

                </Masonry>
              </>
            )}
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    data: state.data.dashboard,
    projectConfig: state.data.projectConfig,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardCustomer)));
